const CurvedArrowRight = () => (
  <>
    <path
      fill="currentColor"
      d="M19.062 13.539a8.6 8.6 0 0 0-3.17-2.944 8.7 8.7 0 0 0-4.2-1.057 8.7 8.7 0 0 0-4.474 1.213 8.73 8.73 0 0 0-3.245 3.316.6.6 0 0 1-.314.276.43.43 0 0 1-.388-.024.46.46 0 0 1-.253-.315.56.56 0 0 1 .053-.408 9.8 9.8 0 0 1 3.61-3.706 9.64 9.64 0 0 1 4.992-1.352 9.55 9.55 0 0 1 4.495 1.102 9.7 9.7 0 0 1 3.482 3.06V8.961q0-.213.143-.356a.48.48 0 0 1 .357-.144q.213 0 .357.144a.48.48 0 0 1 .143.356v4.77a.784.784 0 0 1-.808.808h-4.769a.48.48 0 0 1-.357-.144.48.48 0 0 1-.143-.356q0-.214.143-.357a.48.48 0 0 1 .357-.143z"
    />
  </>
)
export default CurvedArrowRight
